import React from 'react';
import {Button} from './styledComponents';

export const ProxiedButton = props =>{
  const drink = (evt) =>{

    props.action();//state hoist yo!
  }
  return(
    <Button buttonPadding="12px" onClick={drink}><span>{props.label}</span></Button>
  )
}



// WEBPACK FOOTER //
// ./../../../Documents/codeprojects/leaflet-v02/src/components/interfaces.js